import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './stylesheets/global.scss';
import config from './config';
import { isLiveEnvironment, isSentryEnabled } from './utilities/functionHelpers';
import AppRoutes from './components/App/AppRoutes';

if (isSentryEnabled()) {
	Sentry.init({
		dsn: config.SENTRY_API_URL,
		tunnel: '/api/sentry-relay',
		sendDefaultPii: true,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		environment: isLiveEnvironment() ? 'production' : 'sandbox',
		release: `kyc-frontend@${process.env.APP_VERSION}`,
		tracesSampleRate: 1.0,
		beforeSend(event, hint) {
			const error = hint?.originalException as any;

			const url: string | undefined =
				event.request?.url ?? error?.config?.url ?? error?.request?.url ?? error?.url;

			const status: number | undefined =
				(event.contexts as any)?.response?.status_code ??
				error?.response?.status ??
				error?.status;

			const isTinPath = !!url && url.includes('/tin');

			if ((status === 404 && isTinPath) || status === 401) {
				return null;
			}

			return event;
		}
	});
}

ReactDOM.render(<AppRoutes />, document.getElementById('root'));
